import React, { Component, Fragment } from 'react'
import { Redirect, Route, Switch } from 'react-router-dom'
import { connect } from 'react-redux'
import { IntlProvider } from 'react-intl'
import 'owl.carousel/dist/assets/owl.carousel.css'
import 'owl.carousel/dist/assets/owl.theme.default.css'
import 'react-big-calendar/lib/less/styles.less'
import 'react-toggle-switch/dist/css/switch.min.css'
import 'rmc-drawer/assets/index.css'
import 'styles/bootstrap.scss'
import 'styles/app.scss'
import 'styles/app-rtl.scss'
import '@devexpress/dx-react-grid-bootstrap4/dist/dx-react-grid-bootstrap4.css'
import AppLocale from '../lngProvider'

import MainApp from 'app/index'
import Login from './Login'
import Register from './Register'
import ForgotPassword from './ForgotPassword'
import asyncComponent from 'util/asyncComponent'

const RestrictedRoute = ({ component: Component, authenticated, ...rest}) =>
  <Route
    {...rest}
    render={props =>
      authenticated
        ? <Component {...props} />
        : <Redirect
          to={{
            pathname: '/login',
            state: {from: props.location}
          }}
        />}
  />

class App extends Component {
  render () {
    const { match, location, locale, darkTheme, isDirectionRTL, authenticated } = this.props
    if (location.pathname === '/') {
      if (!authenticated) {
        return ( <Redirect to={'/login'}/> )
      } else {
        return ( <Redirect to={'/app/'}/> )
      }
    }

    // for RTL Support
    if (isDirectionRTL) {
      document.body.classList.add('rtl')
    } else {
      document.body.classList.remove('rtl')
    }
    if (darkTheme) {
      document.body.classList.add('dark-theme')
    }

    const currentAppLocale = AppLocale[locale.locale]
    return (
      <Fragment>
        <IntlProvider
          locale={currentAppLocale.locale}
          messages={currentAppLocale.messages}
        >
          <div className='app-main'>
            <Switch>
              <RestrictedRoute path={`${match.url}app`} authenticated={authenticated}
                               component={MainApp}/>
              <Route path='/login' component={Login} />
              <Route path='/register' component={Register} />
              <Route path='/forgot-password' component={ForgotPassword} />
              <Route
                component={asyncComponent(() => import('components/Error404'))} />
            </Switch>
          </div>
        </IntlProvider>
      </Fragment>
    )
  }
}

const mapStateToProps = ({ settings, auth }) => {
  const { locale, isDirectionRTL, darkTheme } = settings
  const { authenticated } = auth
  return { locale, isDirectionRTL, darkTheme, authenticated }
}

export default connect(mapStateToProps)(App)



// WEBPACK FOOTER //
// ./containers/App.js